import { userApi } from "@/core/data/api";

export default async (data) => {
  return await userApi.uploadAvatar(data);
};
